const routeImporters = {
  '/': () => import('../pages/Index'),
  '/karriere': () => import('../pages/Karriere'),
  '/impressum': () => import('../pages/Legal'),
  '/datenschutz': () => import('../pages/Legal'),
  '/agb': () => import('../pages/Legal'),
  '/admin': () => import('../pages/Admin'),
  '/404': () => import('../pages/NotFound'),
} as const;

type PrefetchRoute = keyof typeof routeImporters;

const prefetchedRoutes = new Set<PrefetchRoute>();

export const getRouteImporter = (route: PrefetchRoute) => routeImporters[route];

export const prefetchRoute = (route: PrefetchRoute) => {
  if (prefetchedRoutes.has(route)) return;
  prefetchedRoutes.add(route);
  void routeImporters[route]();
};

export type { PrefetchRoute };
